<template>
  <div class="forgot grid h100" v-loading="loading">


  <div class="">

    <h3>Prego inserisci la tua nuova password</h3>

    <div class="spacer sm"></div>
    
    <el-form :model="formel" :rules="rules" ref="formLogin" @keyup.enter.native="forgot('formLogin')" status-icon>
        <el-form-item prop="password">
            <el-input v-model="formel.password" show-password placeholder="Password" prefix-icon="fas fa-key" name="password"></el-input>
          </el-form-item>
        <div class="spacer xs"></div>
        <el-form-item>
          <el-button class="btn btn-blue block" @click="forgot('formLogin')">cambia password</el-button>
        </el-form-item>
      </el-form>

  </div>


  </div>
</template>

<script>
var host = process.env.ROOT_API
import router from './../router'
export default {
  name: 'hello',
  data () {
    return {
      loading: false,
      formel: {
        email: '',
        password: ''
      },
      rules: {
        password: [
            { required: true, message: 'prego inserisci una password', trigger: 'blur' },
            { min: 8, message: 'lunghezza minima 8 caratteri', trigger: 'blur' }
        ]
      },
      error: {
        state: false,
        message: ''
      },
      success: {
        state: false,
        message: ''
      }
    }
  },
  methods: {
    forgot (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('login')
          this.loading = true
          setTimeout(() => {
            this.loading = false
          }, 2000)
          this.error.state = false
          this.$http
            .post(host + '/resetpassword', {email: this.formel.email.toLowerCase().trim(), password: this.formel.password},
            ).then((data) => {
              router.replace('/')
              this.loading = false
            }, (error) => {
              console.log(error)
              // this.loading = false
              setTimeout(() => {
                this.loading = false
              }, 1000)
              this.error.state = true
              this.error.message = error.body.error
            })
        } else {
          console.log('error submit!!')
          // return false
        }
      })
    },
    getHotel () {
      this.$http
        .post(host + '/checkreset', { token: this.$route.params.token }
        ).then((data) => {
          console.log(data)
          this.formel.email = data.body.email
          this.loading = false
        }, (error) => {
          console.log(error)
          // router.replace('/')
          this.loading = false
          this.error.state = true
          this.error.message = error.body.error
        })
    }
  },
  beforeMount () {
    this.getHotel()
  },
  mounted: function () {
    // this.$refs.emailinput.focus()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?78385ec2